module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_nursing-c6e9f57ec767f2b535b4449b8bf8c3dc.png";